import React, { useEffect, useState } from 'react';
import MemberLayout from '../../components/MemberLayout';
import { getMyAppointments, bookAppointment } from '../../services/api';

const TYPES = [
  { value: 'CONSULTATION', label: 'Consultation' },
  { value: 'OFFICE_VISIT', label: 'Office Visit' },
  { value: 'ONLINE_MEETING', label: 'Online Meeting' },
];

export default function Appointments() {
  const [appointments, setAppointments] = useState([]);
  const [form, setForm] = useState({ type: 'CONSULTATION', requestedDateTime: '', notes: '' });
  const [loading, setLoading] = useState(false);

  const loadAppointments = () => {
    getMyAppointments().then((res) => setAppointments(res.data)).catch(() => {});
  };

  useEffect(() => { loadAppointments(); }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await bookAppointment(form);
      setForm({ type: 'CONSULTATION', requestedDateTime: '', notes: '' });
      loadAppointments();
    } finally {
      setLoading(false);
    }
  };

  return (
    <MemberLayout title="Appointments">
      <form onSubmit={handleSubmit} className="card" style={{ marginBottom: 24, maxWidth: 480 }}>
        <div className="form-group">
          <label>Appointment Type</label>
          <select value={form.type} onChange={(e) => setForm({ ...form, type: e.target.value })}>
            {TYPES.map((t) => <option key={t.value} value={t.value}>{t.label}</option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Preferred Date & Time</label>
          <input
            type="datetime-local"
            required
            value={form.requestedDateTime}
            onChange={(e) => setForm({ ...form, requestedDateTime: e.target.value })}
          />
        </div>
        <div className="form-group">
          <label>Notes (optional)</label>
          <textarea rows="3" value={form.notes} onChange={(e) => setForm({ ...form, notes: e.target.value })} />
        </div>
        <button className="btn btn-gold" disabled={loading}>{loading ? 'Booking...' : 'Book Appointment'}</button>
      </form>

      {appointments.length === 0 ? (
        <p>You have no appointments booked.</p>
      ) : (
        <div className="card">
          <ul style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
            {appointments.map((a) => (
              <li key={a.id} style={{ display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #eee', paddingBottom: 10 }}>
                <span>{TYPES.find((t) => t.value === a.type)?.label || a.type} — {new Date(a.requestedDateTime).toLocaleString()}</span>
                <span className="badge badge-pending">{a.status}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </MemberLayout>
  );
}
